// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'caret-up';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m4 12 4.764-4.9A.333.333 0 0 1 9 7a.325.325 0 0 1 .236.1L14 12'
  />
);

export const viewBox = '0 0 18 18';
